// extracted by mini-css-extract-plugin
export default {"root":"Apps_root__NRpxD","link":"Apps_link__n8cmQ"};